import { useState, useRef, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { ChevronDown, Search, X } from "lucide-react";

export function MemberSearchSelect({ people, value, onChange, placeholder = "Search & select a member", testid, clearable = false }) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const sel = (people || []).find((p) => p.id === value);
  const filtered = (people || []).filter((p) => p.name.toLowerCase().includes(q.trim().toLowerCase()));

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid={testid}>
      <button type="button" onClick={() => setOpen((o) => !o)}
        className="h-9 w-full rounded-lg border border-border bg-background px-3 text-sm flex items-center justify-between gap-2"
        data-testid={`${testid}-trigger`}>
        <span className={sel ? "" : "text-muted-foreground"}>{sel ? sel.name : placeholder}</span>
        <span className="flex items-center gap-1 shrink-0">
          {clearable && sel && (
            <span role="button" tabIndex={0} onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="text-muted-foreground hover:text-destructive" data-testid={`${testid}-clear`}><X className="h-3.5 w-3.5" /></span>
          )}
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        </span>
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full rounded-lg border border-border bg-popover shadow-lg p-1.5">
          <div className="relative mb-1">
            <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
            <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Type a name…"
              className="h-8 pl-8 text-sm" data-testid={`${testid}-search`} />
          </div>
          <div className="max-h-48 overflow-auto">
            {filtered.length === 0 && <p className="px-2 py-1.5 text-xs text-muted-foreground">No matches</p>}
            {filtered.map((p) => (
              <button key={p.id} type="button" onClick={() => { onChange(p.id); setOpen(false); setQ(""); }}
                className={`w-full text-left px-2 py-1.5 rounded-md hover:bg-secondary text-sm ${p.id === value ? "bg-secondary font-medium" : ""}`}
                data-testid={`${testid}-opt-${p.id}`}>{p.name}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
